import { FaImage } from "react-icons/fa";

import React from "react";
import { Col, Row } from "../../../ApiS/Grid-system/Grid-system";
import Title from "../../Title/Title";
import Search from "../../Search/Search";

export default function Exam_Penalties_Inquiry() {
  return (
    <>
      <Row>
        <Col>
          <Title title="استعلام العقوبات الامتحانية" />
        </Col>
      </Row>

      <Row>
        <Col lg={11} className="flex justify-center">
          <Search
            placeholder="رقم الطالب / اسم الطالب / اسم الاب"
            className="!w-[80%] border-2 border-[#efc5e6]"
          />
        </Col>
      </Row>

      <Row className="lg:!w-[1250px]">
        <Col lg={11} md={4} className="mx-auto overflow-x-auto">
          <table className=" max-xl:!w-[1000px] bg-slate-100  max-lg:!w-[850px] mx-auto my-5 text-center rounded-2xl overflow-hidden ">
            <thead className=" bg-[#efc5e6] text-black h-[70px] font-bold text-base">
              <tr>
                <td className="px-1">رقم الحساب</td>
                <td className="px-16"> اسم الطالب ونسبته</td>
                <td className="px-16"> اسم الاب</td>
                <td className="px-16"> اسم الام</td>
                <td className="px-16"> الرقم الوطني</td>
                <td className="px-16"> رقم قرار لجنة الانضباط</td>
                <td className="px-16"> تاريخ قرار لجنة الانضباط</td>
                <td className="px-16"> نوع العقوبة</td>
                <td className="px-16"> عدد فترات الحرمان</td>
                <td className="px-16"> رقم قرار لجنة التظلم</td>
                <td className="px-16"> تاريخه</td>
                <td className="px-16"> قرار اللجنة</td>
                <td className="px-16"> عدد فترات الحرمان</td>
                <td className="px-16"> امكانية تحميل صورة القرار</td>
              </tr>
            </thead>

            <tbody className="h-[70px]">
              <tr className="border-2 border-white">
                <td>215</td>
                <td>محمد احمد</td>
                <td> احمد</td>
                <td> سعاد</td>
                <td> 1325513515</td>
                <td> 21524</td>
                <td> 5/5/2023</td>
                <td> حرمان</td>
                <td> دورتين</td>
                <td> 100</td>
                <td> 14/7/2024</td>
                <td> فصل</td>
                <td> دورتين</td>
                <td>
                  {" "}
                  <div className="flex justify-center cursor-pointer">
                    {" "}
                    <FaImage size={20} className="mx-2 text-red-800" /> تحميل
                  </div>{" "}
                </td>
              </tr>
            </tbody>
          </table>
        </Col>
      </Row>
    </>
  );
}
